export default __webpack_public_path__ + "static/media/how_it_works_bg.b3c55773.png";